(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('ParameterFranchiserListController', ParameterFranchiserListController)

    /** @ngInject */
    function ParameterFranchiserListController(UtilHelper, LoadingHelper, ParameterService, sweetAlert) {
        const vm = this;

        let isTableSearch = false;
        let forcePaginationReset = false;

        vm.isSearchDisabled = () => {
            if (vm.selectedSearchField && vm.searchText)
                return false;

            return true;
        }

        vm.isClearDisabled = () => {
            if (isTableSearch)
                return false;

            if (vm.selectedSearchField || vm.searchText)
                return false;

            return true;
        }

        vm.doSearch = (event, isFromButton) => {
            if (!vm.isSearchDisabled() && (event && event.keyCode == 13) || isFromButton) {
                forcePaginationReset = true;

                vm.tableCallServer();
            }
        }

        vm.clearSearch = () => {
            vm.selectedSearchField = null;
            vm.searchText = null;

            if (isTableSearch)
                vm.tableCallServer();

            isTableSearch = false;
        }

        vm.tableCallServer = (tableState, stCtrl) => {
            if (!vm.stCtrl && stCtrl)
                vm.stCtrl = stCtrl;

            if (!tableState && vm.stCtrl) {
                vm.stCtrl.pipe();
                return;
            }

            vm.isLoading = true;

            if (forcePaginationReset) {
                tableState.pagination.start = 0;
                forcePaginationReset = false;
            }

            const pagination = tableState.pagination;
            const start = pagination.start || 0;
            const number = pagination.number || 10;

            getParameters(start, number, tableState);
        }

        vm.openParameterModal = (parameter = null) => {
            let modalAction = 'NOVO';

            if (parameter) {
                vm.parameterData = angular.copy(parameter);
                vm.parameterData.RegistrationDateFormatted = parameter.RegistrationDate ? moment(parameter.RegistrationDate).format('DD/MM/YYYY HH:mm') : '';

                modalAction = 'EDITAR';
            }

            vm.modalAction = modalAction;

            $('#company-parameter').appendTo('body').modal('show');
        }

        vm.closeParameterModal = () => {
            vm.parameterData = null;

            vm.parameterForm.reset();

            $('#company-parameter').modal('hide');
        }

        vm.saveParameter = () => {
            LoadingHelper.startLoading('.modal-loader');

            if (!vm.parameterData.Id) {
                ParameterService
                    .post(vm.parameterData)
                    .then(() => successCallback(true), errorCallback);
            } else {
                let parameterData = {
                    Id: vm.parameterData.Id,
                    Title: vm.parameterData.Title
                };

                ParameterService
                    .put(parameterData)
                    .then(() => successCallback(false), errorCallback);
            }
        }

        vm.deleteParameter = parameterId => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Não é possível desfazer essa ação!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    LoadingHelper.startLoading('.loading-holder');

                    ParameterService
                        .deleteData(parameterId)
                        .then(() => {
                            vm.tableCallServer();
                            LoadingHelper.stopLoading('.loading-holder');
                            UtilHelper.successCallback('delete');
                        }, error => {
                            UtilHelper.errorCallback(error);
                            LoadingHelper.stopLoading('.loading-holder');
                        })
                }
            })
        }

        init();

        function getParameters(skip, perPage, tableState) {
            let parameters = prepareParameters(skip, perPage, tableState);

            ParameterService
                .getByParameters(parameters)
                .then(success => {
                    vm.parameters = success.Registers;
                    tableState.pagination.numberOfPages = success.NumberOfPages;

                    vm.isLoading = false;
                }, error => {
                    vm.parameters = null;
                    vm.isLoading = false;
                    UtilHelper.errorCallback(error);
                })
        }

        function prepareParameters(skip, perPage, tableState) {
            let params = {
                Skip: skip,
                PerPage: perPage,
                OrderBy: 'RegistrationDate',
                OrderDescending: false
            }

            if (vm.selectedSearchField && vm.searchText)
                isTableSearch = true;

            if (tableState && tableState.sort.predicate) {
                params.OrderBy = tableState.sort.predicate;
                params.OrderDescending = tableState.sort.reverse;
            }

            if (vm.selectedSearchField && vm.searchText)
                params[vm.selectedSearchField.Value] = vm.searchText;

            return params;
        }

        function successCallback(isPost) {
            UtilHelper.successCallback(isPost ? 'create' : 'update');
            vm.tableCallServer();
            vm.closeParameterModal();

            LoadingHelper.stopLoading('.modal-loader');
        }

        function errorCallback(error) {
            LoadingHelper.stopLoading('.modal-loader');
            UtilHelper.errorCallback(error);
        }

        function init() {
            vm.selectedSearchField;
            vm.searchText;
            vm.isLoading = true;

            vm.searchFields = [{
                Value: 'Name',
                Description: 'Descrição'
            }];
        }
    }
}());